<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <div class="type-wrap">
        <router-link to="/" class="skip">首页></router-link>
        <router-link class="skip" :to="type==1? '/about/perspective' : '/about/culture'">{{type==1? '伟嘉视角>': '企业文化>'}}</router-link>
        <span class="type-name">详情</span>
      </div>
      <div class="page__title">
        <h2 class="large__title">文章详情</h2>
        <h4 class="small__title square">ARTICLE DETAILS</h4>
      </div>
      <div class="articles-content">
        <h3 class="article-title">{{info.title}}</h3>
        <p class="articles-top text-right" style="font-weight: 900">
          <span>发布日期：{{info.addDate}}</span>
        </p>
        <div class="articles-txt" v-html="info.content"></div>
      </div>
      <div class="page-caption">
        <div class="point"></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    data () {
      return {
        info: {},
        articleId: null,
        type: null
      }
    },
    created () {
      this.articleId = this.$route.params.id
      this._fetchData()
    },
    methods: {
      _fetchData () {
        if (/perspective/.test(this.$route.path)) {
          this.type = 1
        } else {
          this.type = 2
        }
        let vm = this
        this.$http({
          url: '/getArticleInfo.jhtml',
          data: {
            type: this.type,
            articleId: this.articleId
          },
          done (info) {
            vm.info = info || {}
          }
        })
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
.main-container
  padding-top 44px
  .page__title
    .large__title
      letter-spacing 16px
    .small__title
      padding-left 135px
      &:after
        margin-left -87px
        width 70px

  .articles-content
    margin-top 32px
    font-size 16px
    color #333
    .article-title
      margin 0
      padding 0
      text-align center
      font-size 18px
      color #333
      margin-bottom 18px
    .articles-txt
      margin-top 8px
      padding 15px 20px
      overflow hidden
      font-size 16px
      line-height 30px
      color #333
      letter-spacing 2px

  .type-wrap
    position absolute
    top 24px
    font-size 12px
    span
      color #333
    .type-name
      font-family MicrosoftYaHei
      color #2b9efc
     .skip
      text-decoration none
      color #333
</style>



// WEBPACK FOOTER //
// articles.vue?9ceb1752